import { getJson } from 'utils/http/getJson';

import { ApiUserLocation } from './types/ApiUserLocation';

export function fetchUserLocation(): Promise<ApiUserLocation> {
  return getJson('/data/user-location').then(
    // @ts-expect-error TS(2345): Argument of type '({ location }: { location: any; ... Remove this comment to see the full error message
    ({ location }) => location,
  );
}
